export const defaultPhoneNumber = "1300592227"
